import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=46b83e70&scoped=true&"
import script from "./portfolio.vue?vue&type=script&lang=js&"
export * from "./portfolio.vue?vue&type=script&lang=js&"
import style0 from "./portfolio.vue?vue&type=style&index=0&id=46b83e70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b83e70",
  null
  
)

export default component.exports